
import { Vue, Component, Prop } from "vue-property-decorator";
import OnTimeMetricWidget from "@/components/widgets/metrics/OnTimeMetricWidget.vue";
import ScanComplianceMetricWidget from "@/components/widgets/metrics/ScanComplianceMetricWidget.vue";
import SurveyEngagementWidget from "./SurveyEngagementWidget.vue";
import DamageShortMetricWidget from "./DamageShortMetricWidget.vue";
import { WidgetResource, WidgetSettingResource } from "@/models/api/system/widgets";
import { getModule } from "vuex-module-decorators";
import WidgetModule from "@/store/modules/widgets";

const widgetModule = getModule(WidgetModule);

@Component({
  components: {
    OnTimeMetricWidget,
    ScanComplianceMetricWidget,
    SurveyEngagementWidget,
    DamageShortMetricWidget
  }
})
export default class MetricWidget extends Vue {
    @Prop({ required: true})
    widgetSetting: WidgetSettingResource;

    @Prop({ required: true})
    widgets: Array<WidgetResource>;   

    getWidgetClass(): string {
        var widgetType = this.widgets.find(x => x.name == this.widgetSetting.name);
        return `item-w${widgetType?.width}`;
    }

    configure() {
      if (this.widgetSetting.name == 'OnTime') {
            (this.$refs.onTimeMetricWidget as OnTimeMetricWidget).configure();
      }

      if (this.widgetSetting.name == 'ScanCompliance') {
          (this.$refs.scanComplianceMetricWidget as ScanComplianceMetricWidget).configure();
      }

      if (this.widgetSetting.name == 'SurveyEngagement') {
          (this.$refs.surveyEngagementMetricWidget as SurveyEngagementWidget).configure();
      }

      if (this.widgetSetting.name == 'DamageShort') {
          (this.$refs.damageShortMetricWidget as SurveyEngagementWidget).configure();
      }
    }

    isDrillDownAvailable() {
      if (this.widgetSetting.name == 'OnTime' && this.$refs.onTimeMetricWidget) {
          return (this.$refs.onTimeMetricWidget as OnTimeMetricWidget).isDrillDownAvailable();
      }

      if (this.widgetSetting.name == 'ScanCompliance' && this.$refs.scanComplianceMetricWidget) {
        return (this.$refs.scanComplianceMetricWidget as ScanComplianceMetricWidget).isDrillDownAvailable();
      }

      if (this.widgetSetting.name == 'SurveyEngagement' && this.$refs.surveyEngagementMetricWidget) {
        return (this.$refs.surveyEngagementMetricWidget as SurveyEngagementWidget).isDrillDownAvailable();
      }

      if (this.widgetSetting.name == 'DamageShort' && this.$refs.damageShortMetricWidget) {
        return (this.$refs.damageShortMetricWidget as SurveyEngagementWidget).isDrillDownAvailable();
      }

      return false;
    }

    showDrillDown() {
      if (this.widgetSetting.name == 'OnTime') {
          (this.$refs.onTimeMetricWidget as OnTimeMetricWidget).showDrillDown();
      }

      if (this.widgetSetting.name == 'ScanCompliance') {
          (this.$refs.scanComplianceMetricWidget as ScanComplianceMetricWidget).showDrillDown();
      }

      if (this.widgetSetting.name == 'SurveyEngagement') {
          (this.$refs.surveyEngagementMetricWidget as SurveyEngagementWidget).showDrillDown();
      }

      if (this.widgetSetting.name == 'DamageShort') {
          (this.$refs.damageShortMetricWidget as SurveyEngagementWidget).showDrillDown();
      }
    }

    async refresh() {
      if (this.widgetSetting.name == 'OnTime') {
          await (this.$refs.onTimeMetricWidget as OnTimeMetricWidget).loadMetricData();
      }

      if (this.widgetSetting.name == 'ScanCompliance') {
          (this.$refs.scanComplianceMetricWidget as ScanComplianceMetricWidget).loadMetricData();
      }

      if (this.widgetSetting.name == 'SurveyEngagement') {
          (this.$refs.surveyEngagementMetricWidget as SurveyEngagementWidget).loadMetricData();
      }

      if (this.widgetSetting.name == 'DamageShort') {
          (this.$refs.damageShortMetricWidget as SurveyEngagementWidget).loadMetricData();
      }
    }

    async remove(widgetSettingId: number) {
      await widgetModule.deleteWidgetSetting(widgetSettingId);
      this.$emit('removed', this.widgetSetting.id);

    }
}
